import React from 'react';
import Hero from '../components/home/Hero';

function HomePage() {
  return <Hero />;
}

export default HomePage;